import { Divider, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HomeIcon from '@mui/icons-material/Home';
import LayersIcon from '@mui/icons-material/Layers';
import HelpIcon from '@mui/icons-material/Help';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { ROUTES } from './consts';
import { forwardRef } from 'react';

interface CustomNavLinkProps extends NavLinkProps {
  activeClassName: string;
}
const CustomNavLink = forwardRef<HTMLAnchorElement, CustomNavLinkProps>((props, ref) => (
  <NavLink
    ref={ref}
    to={props.to}
    className={({ isActive }) => `${props.className} ${isActive ? props.activeClassName : ''}`}
  >
    {props.children}
  </NavLink>
));

export const mainListItems = (
  <div>
    <ListItemButton
      component={CustomNavLink}
      to={ROUTES.app.href}
      activeClassName="Mui-selected"
    >
      <ListItemIcon>
        <HomeIcon />
      </ListItemIcon>
      <ListItemText primary="Home" />
    </ListItemButton>
    <ListItemButton
      component={CustomNavLink}
      to={ROUTES.generator.href}
      activeClassName="Mui-selected"
    >
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Generator" />
    </ListItemButton>
    <ListItemButton
      component={CustomNavLink}
      to={ROUTES.templates.href}
      activeClassName="Mui-selected"
    >
      <ListItemIcon>
        <LayersIcon />
      </ListItemIcon>
      <ListItemText primary="Szablony" />
    </ListItemButton>
    <Divider/>
    <ListItemButton
      component={CustomNavLink}
      to={ROUTES.help.href}
      activeClassName="Mui-selected"
    >
      <ListItemIcon>
        <HelpIcon />
      </ListItemIcon>
      <ListItemText primary="Pomoc" />
    </ListItemButton>
  </div>
);
